// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bba_a"};